import { cva } from 'class-variance-authority'

export const wrapperStyles = cva(
  `
    flex
    justify-around
    w-fit
    p-2
    rounded-lg
  `,
  {
    variants: {
      variant: {
        default: 'bg-moss-0',
        priority: 'bg-priority-0',
        success: 'bg-success-0',
        warning: 'bg-warning-0',
        danger: 'bg-danger-0',
        announcement: 'bg-moss-50 w-full rounded-none p-4 justify-center',
        urgent: 'bg-priority-50 w-full rounded-none p-4 justify-center',
      },
      betaMediaSize: {
        default: '',
        sm: 'w-80',
        md: '',
        lg: '',
      },
    },
    defaultVariants: {
      variant: 'default',
      betaMediaSize: 'default',
    },
  }
)

export const styles = cva(
  `
    inline-flex
    items-center
  `,
  {
    variants: {
      variant: {
        default: '',
        priority: '',
        success: '',
        warning: '',
        danger: '',
        announcement: 'grow justify-center',
        urgent: 'grow justify-center gap-4',
      },
      betaMediaSize: {
        default: '',
        sm: 'gap-2 items-start flex-col',
        md: '',
        lg: '',
      },
    },
    defaultVariants: {
      variant: 'default',
      betaMediaSize: 'default',
    },
  }
)

export const buttonStyles = cva(
  `
    inline-flex
    items-center
    gap-0
    cursor-pointer
    text-inherit
    hover:text-current
    underline
    p-0
    leading-none
    align-baseline
    ml-2
  `
)

export const iconStyles = cva(
  `
    pr-2
    pl-1
  `,
  {
    variants: {
      variant: {
        default: 'text-neutral-600',
        priority: 'text-priority-200',
        success: 'text-success-100',
        warning: 'text-warning-200',
        danger: 'text-danger-100',
        announcement: 'text-neutral-900',
        urgent: 'text-neutral-900',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
)

export const textStyles = cva(
  `
  `,
  {
    variants: {
      variant: {
        default: 'text-neutral-600',
        priority: 'text-priority-200',
        success: 'text-success-100',
        warning: 'text-warning-200',
        danger: 'text-danger-100',
        announcement: 'text-neutral-700',
        urgent: 'text-neutral-700',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
)

export const titleStyles = cva(
  `
    pr-3
    font-bold
  `
)

export const dismissStyles = cva(
  `
    text-neutral-500
    cursor-pointer
  `
)
